import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { AuthUser } from '@/shared/auth/store';

export interface RouterContext {
  auth: {
    user: AuthUser | null;
    isAuthenticated: boolean;
  };
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <Outlet />
    </div>
  );
}
